import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// Used by content
import "./ExchangeVariantSelector.js";

/**
* class HSN.BagModal
*
* Encapsulates the functionality of a modal dialog that allows the user to edit their shipping address.
**/
HSN.ExchangeModal = (function (parent) {
    __extends(ExchangeModal, parent);

    function ExchangeModal() {
        /**
        * new HSN.ExchangeModal()
        **/
        var modal = ExchangeModal.__super__.constructor.call(this);
            
        return modal;
    }

    ExchangeModal.prototype.ShowComplete = function(ordernum, sku) {
        $.ajax("/myaccount/orders/exchangecomplete/" + ordernum + '/' + sku,
            {
                type: 'GET',
                context: this,
                dataType: 'html',
                data: {},
                success: function (data) {
                    var scope = this;

                    scope.Root.removeClass('loading');
                    this.Content.showHtml(
                        data,
                        0,
                        function () {
                            scope.Center();
                            scope.Content.animate({ opacity: 1 });
                        },
                        function () {
                            //scope.Center();
                        }
                    );
                },
                error: function () {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    }

    ExchangeModal.prototype._show = function (ordernum) {
        $.ajax("/myaccount/orders/exchange/" + ordernum,
            {
                type: 'GET',
                context: this,
                dataType: 'html',
                data: {},
                success: function (data) {
                    var scope = this;

                    scope.Root.removeClass('loading');
                    this.Content.showHtml(
                        data,
                        0,
                        function () {
                            scope.Center();
                            scope.Content.animate({ opacity: 1 });
                        },
                        function () {
                            //scope.Center();
                        }
                    );
                },
                error: function () {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };

    return ExchangeModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Exchange/ExchangeModal.js